export default __webpack_public_path__ + "static/media/IsaacOptimized.1edd1dac.jp2";